import TableContainer from '@material-ui/core/TableContainer';
//import styled from 'styled-components';

export const UIUIDataTableContainerFullWidthOverflow = TableContainer;

export default UIUIDataTableContainerFullWidthOverflow;
